(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class BundleBuilderForm extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
      this.countEl = this.querySelector('[data-bundle-count]');
      this.subtotalEl = this.querySelector('[data-bundle-subtotal]');
      this.savingEl = this.querySelector('[data-bundle-saving]');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.hintEl = this.querySelector('[data-bundle-hint]');
      this.progressMessageEl = this.querySelector('[data-bundle-progress-message]');
      this.submitButton = this.querySelector('[data-bundle-submit]');
      this.summaryEl = this.querySelector('.bundle-builder__summary');
      this.discountMeterEl = this.querySelector('.bundle-builder__discount-meter');
      this.progressEl = this.querySelector('[data-bundle-progress]');
      this.progressFillEl = this.querySelector('[data-bundle-progress-fill]');
      this.discountThreshold = 3;
      this.discountRate = 0.15;
      this.isDiscountUnlocked = false;
      this.celebrationTimeout = null;

      this.items.forEach((item) => {
        item.quantity = 0;
        item.querySelector('[data-quantity-increase]').addEventListener('click', () => {
          item.quantity += 1;
          this.update();
        });
        item.querySelector('[data-quantity-decrease]').addEventListener('click', () => {
          item.quantity = Math.max(0, item.quantity - 1);
          this.update();
        });
      });

      this.submitButton.addEventListener('click', () => this.addToCart());
      this.update();
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP',
      }).format(cents / 100);
    }

    getSelection() {
      return this.items
        .map((item) => ({
          id: Number(item.dataset.variantId),
          quantity: item.quantity,
          price: Number(item.dataset.price),
          element: item,
        }))
        .filter((item) => item.quantity > 0);
    }

    update() {
      const selection = this.getSelection();
      const count = selection.reduce((sum, item) => sum + item.quantity, 0);
      const subtotal = selection.reduce((sum, item) => sum + item.quantity * item.price, 0);
      const saving = count >= this.discountThreshold ? Math.round(subtotal * this.discountRate) : 0;

      this.items.forEach((item) => {
        item.querySelector('[data-quantity-value]').textContent = item.quantity;
        item.classList.toggle('is-selected', item.quantity > 0);
      });

      this.countEl.textContent = count;
      this.subtotalEl.textContent = this.formatMoney(subtotal);
      this.savingEl.textContent = this.formatMoney(saving);
      this.totalEl.textContent = this.formatMoney(subtotal - saving);
      const isUnlocked = count >= this.discountThreshold;
      const hintText = isUnlocked
        ? this.summaryEl.dataset.bundleUnlockedText
        : (this.discountThreshold - count === 1
          ? this.summaryEl.dataset.bundleChooseMorePairText
          : this.summaryEl.dataset.bundleChooseMorePairsText
        ).replace('[count]', this.discountThreshold - count);

      this.submitButton.disabled = count === 0;
      this.updateProgress(count);
      this.hintEl.textContent = hintText;
      this.progressMessageEl.textContent = isUnlocked
        ? this.summaryEl.dataset.bundleUnlockedText
        : this.progressMessageEl.dataset.bundleProgressText;
      this.discountMeterEl?.classList.toggle('is-unlocked', isUnlocked);

      if (isUnlocked && !this.isDiscountUnlocked) {
        this.celebrateUnlock();
      }

      this.isDiscountUnlocked = isUnlocked;
    }

    updateProgress(count) {
      const cappedCount = Math.min(count, this.discountThreshold);
      const progressPercent = (cappedCount / this.discountThreshold) * 100;
      const visualProgressWidth = count > 0 ? `${progressPercent}%` : '8px';

      this.progressEl?.setAttribute('aria-valuenow', String(Math.round(progressPercent)));
      this.progressFillEl?.style.setProperty('--bundle-progress', visualProgressWidth);
    }

    celebrateUnlock() {
      if (!this.discountMeterEl) return;

      window.clearTimeout(this.celebrationTimeout);
      this.discountMeterEl.classList.remove('is-celebrating');
      void this.discountMeterEl.offsetWidth;
      this.discountMeterEl.classList.add('is-celebrating');
      this.celebrationTimeout = window.setTimeout(() => {
        this.discountMeterEl?.classList.remove('is-celebrating');
      }, 1400);
    }

    async addToCart() {
      const items = this.getSelection().map((item) => ({ id: item.id, quantity: item.quantity }));
      if (!items.length) return;

      this.submitButton.disabled = true;
      this.submitButton.textContent = this.summaryEl.dataset.bundleAddingText;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = '/cart';
      } catch (error) {
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.summaryEl.dataset.bundleTryAgainText;
      }
    }
  }

  customElements.define('bundle-builder-form', BundleBuilderForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
